import api from "./axiosInstance";

const settingsService = {
  async getCAGlobalSettings() {
    const response = await api.get("/settings/caglobal");
    return response.data;
  },

  async setCAGlobalSettings(settings) {
    const response = await api.put("/settings/caglobal", settings);
    return response.data;
  },

  async getTelegramSettings() {
    const response = await api.get("/settings/telegram");
    return response.data;
  },

  async setTelegramSettings(settings) {
    const response = await api.put("/settings/telegram", settings);
    return response.data;
  },

  async testTelegramSettings(request) {
    const response = await api.post("/settings/telegram/test", request);
    return response.data;
  },
};

export default settingsService;
